// Auth route — Email verification target (US-002).

import { createRoute } from '@tanstack/react-router';

import { VerifyPage } from '@/features/auth/VerifyPage';

import { Route as RootRoute } from '../__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/auth/verify',
  validateSearch: (search): { token?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: VerifyPage,
});
